import { DateRange } from '../../../../shared/components/date-range-picker/date-range-picker.component';
import { getDateRangeForPeriod } from '../../../../rewards/utils/rewards-period.util';

/**
 * Maps admin summary period to ISO start/end dates, or null for All Time.
 */
export function getRewardSummaryDateRange(
  selectedPeriod: string,
  customDateRange: DateRange
): { startDate: string; endDate: string } | null {
  const range = getDateRangeForPeriod(selectedPeriod, customDateRange);
  if (!range) {
    return null;
  }
  return { startDate: range.start, endDate: range.end };
}
